export default class Layout {
	pagesThatShouldNotHaveLayout = ['Exams/'];

	pageShouldHaveDefaultLayout(page_name: string) {
		return !this.pagesThatShouldNotHaveLayout.some((item) =>
			page_name.startsWith(item)
		);
	}
}
